<template>
  <ItemDialog ref="dialogRef" image-type="alert">
    <template #content-area>
      <h2>有効期限を超過しました</h2>
      <p style="text-align: center">本予約は無効になりました</p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogReservationExpired",
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
      nativeHandlerService.returnNativeDbsIndexPage();
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>
